import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const MinusIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
    <path d="M2.5 8h11" strokeLinecap="round" strokeLinejoin="round" />
  </svg>);
export default MinusIcon;